import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PictureViewerService } from './picture-viewer.service';

@Component({
  selector: 'app-picture-viewer',
  templateUrl: './picture-viewer.component.html',
  styleUrls: ['./picture-viewer.component.scss']
})
export class PictureViewerComponent implements OnInit {
  show = false;
  images: string[];
  current: 0;
  isLongerImg = false;
  isWiderImg = false;
  @ViewChild("pictureViewer") viewerImage: ElementRef;
  viewerImageLoaded = false;
  constructor(
    private pictureViewerService: PictureViewerService
  ) {

  }

  ngOnInit(): void {
    this.pictureViewerService.showPictureViewer$.subscribe(r => {
      this.show = true;
      this.images = r.images;
      this.current = r.index;
      setTimeout(() => {
        this.imageLoaded();
      }, 100);
    })
  }

  close() {
    this.show = false;
  }

  prev() {
    if (this.current < this.images.length - 1) {
      this.current += 1;
      this.viewerImageLoaded = false;
      setTimeout(() => {
        this.imageLoaded();
      }, 100);
    }
  }

  next() {
    if (this.current > 0) {
      this.current -= 1;
      this.viewerImageLoaded = false;
      setTimeout(() => {
        this.imageLoaded();
      }, 100);
    }
  }

  imageLoaded() {
    this.isLongerImg = false;
    this.isWiderImg = false;
    if (this.viewerImage === undefined) {
      setTimeout(() => {
        this.imageLoaded();
      }, 100);
    } else if (!this.viewerImage.nativeElement.complete) {
      setTimeout(() => {
        this.imageLoaded();
      }, 100);
    } else {
      const rawWidth = this.viewerImage.nativeElement.naturalWidth;
      const rawHeight = this.viewerImage.nativeElement.naturalHeight;
      // console.log(rawWidth);
      // console.log(rawHeight);
      if (rawHeight > (rawWidth * 2)) {
        this.isLongerImg = true;
      }
      if (rawWidth > (rawHeight * 2.3)) {
        this.isWiderImg = true;
      }
      this.viewerImageLoaded = true;
    }
  }
}
